import { render, staticRenderFns } from "./principioAtivoForm.vue?vue&type=template&id=efe8c754&scoped=true&"
import script from "./principioAtivoForm.vue?vue&type=script&lang=js&"
export * from "./principioAtivoForm.vue?vue&type=script&lang=js&"
import style0 from "./principioAtivoForm.vue?vue&type=style&index=0&id=efe8c754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe8c754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VTextField})
